export default {
  STRIP_COLUMNS_CONTAINER: '03307822-99c1-4c03-af2b-ff4da8c711ae',
  SLIDE_SHOW: '6e2400a3-e990-4bdc-ab4f-8e787a2c50de',
  COLUMN: '17c69f9a-4d11-4b49-a2b2-078127bf0249',
  POPUP: 'c232519b-8959-4f15-a202-30120ee84e46',
  HOVER_BOX: 'e4bef919-9630-4062-ae1d-210a81b527a0',
  CLASSIC_SECTION: 'd31662ae-ff3a-42b0-904b-9927de50c127',
};
